export const SET_ERROR = "ERROR | SET_ERROR";
export const RESET_ERROR = "ERROR | RESET_ERROR";

export function displayError()
{
  return setError({display: true});
}

export function setError(data) {
  return { type: SET_ERROR, payload: data };
}

export function resetError() {
  return { type: RESET_ERROR };
}




// WEBPACK FOOTER //
// ./src/store/actions/error.js